window.setImmediate = (fn: () => void) => {
  return setTimeout(fn, 0);
};

// polyfill for requestIdleCallback
window.requestIdleCallback =
  window.requestIdleCallback ||
  function(cb: (deadline: RequestIdleCallback) => any) {
    const start = Date.now();
    return setTimeout(function() {
      cb({
        didTimeout: false,
        timeRemaining: function() {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function(id: number) {
    clearTimeout(id);
  };

